<input [formControl]="control" [id]="field.key" [dpDayPicker]="config" [mode]="'time'" type="time">